import React, { useState } from 'react';
import { WrenchIcon, ThermometerIcon, FanIcon, ShieldCheckIcon } from 'lucide-react';
import { ContactModal } from './ContactModal';
export function ServicesSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCTA = () => {
    if (window.innerWidth < 640) {
      window.location.href = 'tel:6025842141';
    } else {
      setIsModalOpen(true);
    }
  };
  const services = [{
    title: 'AC Installation',
    description: 'Expert installation of high-efficiency cooling systems built for the Arizona heat. Done right, the first time.',
    icon: <FanIcon className="h-8 w-8" data-id="element-162" />
  }, {
    title: 'Repair Service',
    description: 'Fast, reliable repairs when you need them most. We diagnose it honest and fix it right.',
    icon: <WrenchIcon className="h-8 w-8" data-id="element-163" />
  }, {
    title: 'Heating Systems',
    description: 'Keep your family warm on chilly desert nights. Quality heating solutions for every home.',
    icon: <ThermometerIcon className="h-8 w-8" data-id="element-164" />
  }, {
    title: 'Maintenance',
    description: 'Prevent breakdowns before they happen. Regular tune-ups that extend the life of your unit.',
    icon: <ShieldCheckIcon className="h-8 w-8" data-id="element-165" />
  }];
  return <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-166" />
      <section id="services" className="py-20 bg-tan relative" data-id="element-167">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
          <div className="text-center mb-16" data-id="element-169">
            <span className="text-orange font-sub text-xl uppercase tracking-widest font-bold" data-id="element-170">
              What We Do
            </span>
            <h2 className="text-4xl md:text-6xl text-navy mt-2 mb-4 drop-shadow-sm" data-id="element-171">
              TOP-TIER HOME COMFORT
            </h2>
            {/* Retro double-rule divider */}
            <div className="flex items-center justify-center gap-2 mt-4" data-id="element-172">
              <div className="h-px w-16 bg-orange/60" data-id="element-173"></div>
              <div className="text-orange text-xl" data-id="element-174">★</div>
              <div className="h-1 w-24 bg-orange" data-id="element-175"></div>
              <div className="text-orange text-xl" data-id="element-176">★</div>
              <div className="h-px w-16 bg-orange/60" data-id="element-177"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178">
            {services.map((service, index) => <button key={index} onClick={handleCTA} className="relative bg-[#f5edd8] shadow-md group cursor-pointer text-left w-full hover:-translate-y-2 hover:shadow-xl transition-all duration-300" style={{
            border: '2px solid #d4c9a8',
            outline: '3px solid #ff571e',
            outlineOffset: '-8px'
          }} data-id="element-179">
                {/* Top orange bar */}
                <div className="h-2 bg-orange w-full" data-id="element-180"></div>

                <div className="p-6 pt-5" data-id="element-181">
                  {/* Icon */}
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-navy flex items-center justify-center border-4 border-[#d4c9a8] shadow-inner group-hover:scale-110 transition-transform duration-300" data-id="element-182">
                    <div className="text-orange" data-id="element-183">{service.icon}</div>
                  </div>

                  <div className="border-t-2 border-dashed border-brown/20 mb-4" data-id="element-184"></div>

                  <h3 className="text-xl text-navy text-center mb-3 font-display uppercase tracking-wide leading-tight" data-id="element-185">
                    {service.title}
                  </h3>

                  <div className="border-t border-orange/30 mb-3" data-id="element-186"></div>

                  <p className="text-brown/75 text-center font-body text-sm leading-relaxed" data-id="element-187">
                    {service.description}
                  </p>
                </div>

                {/* Bottom CTA strip */}
                <div className="bg-navy/10 border-t border-brown/10 py-2 text-center group-hover:bg-orange/10 transition-colors" data-id="element-188">
                  <span className="font-sub text-xs text-navy/60 uppercase tracking-widest group-hover:text-orange transition-colors" data-id="element-189">
                    Get a Free Quote →
                  </span>
                </div>
              </button>)}
          </div>

          {/* Vintage Banner Strip */}
          <div className="mt-16 bg-navy p-8 shadow-xl transform -rotate-1 mx-4 lg:mx-0 border-4 border-cream relative overflow-hidden" data-id="element-190">
            <div className="absolute inset-2 border border-dashed border-cream/20 pointer-events-none" data-id="element-191"></div>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 relative z-10" data-id="element-192">
              <div className="text-center md:text-left" data-id="element-193">
                <h3 className="text-3xl text-cream mb-1" data-id="element-194">
                  NEED EMERGENCY SERVICE?
                </h3>
                <p className="text-blue-200 font-sub text-lg uppercase tracking-wide" data-id="element-195">
                  WE'RE HERE WHEN YOU NEED US MOST.
                </p>
              </div>
              {/* Mobile: direct call. Desktop: modal */}
              <a href="tel:6025842141" className="sm:hidden bg-orange text-white px-8 py-3 font-display text-xl uppercase shadow-lg hover:bg-orange-600 transition-colors whitespace-nowrap" data-id="element-196">
                Call 602-584-2141
              </a>
              <button onClick={() => setIsModalOpen(true)} className="hidden sm:block bg-orange text-white px-8 py-3 font-display text-xl uppercase shadow-lg hover:bg-orange-600 transition-colors whitespace-nowrap" data-id="element-197">
                Call 602-584-2141
              </button>
            </div>
          </div>
        </div>
      </section>
    </>;
}